import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=7144b846&scoped=true&"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7144b846",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VApp,VAutocomplete})
